module.exports = __webpack_public_path__ + "pc/img/img_award2023_04.5c96a138.png";